(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dudes-chat"] && !Shopify.designMode) return;
  try {
    const overlay = document.getElementById('Dudes-Chat-Overlay');
  const closeButton = overlay?.querySelector('[data-dudes-chat-close]');
  let opener;
  let nativeHost;
  let runtimeRoot;
  let pendingTimer;
  let nativeObserver;
  let attempts = 0;
  let bootRequested = false;
  const nativeStyle = `
    .activator-nudge, .backdrop, .panel__size-toggle, .panel__close { display: none !important; }
    .panel { position: fixed !important; inset: auto !important; top: calc(var(--dudes-chat-top) - var(--dudes-chat-height) / 2 + 48px) !important; left: 50% !important; transform: translateX(-50%) !important; width: var(--dudes-chat-width) !important; height: calc(var(--dudes-chat-height) - 48px) !important; min-width: 0 !important; min-height: 0 !important; max-width: none !important; max-height: none !important; margin: 0 !important; border: 0 !important; border-radius: 0 0 14px 14px !important; box-shadow: none !important; z-index: 2147483001 !important; transition: none !important; }
    .panel__header { min-height: 36px !important; height: 36px !important; padding-top: 0 !important; padding-bottom: 0 !important; }
    .panel__body { min-height: 0 !important; flex: 1 !important; }
  `;
  function connect() {
    nativeHost = document.querySelector('shopify-chat');
    runtimeRoot = nativeHost?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
    if (!runtimeRoot && !bootRequested) {
      const initialButton = nativeHost?.shadowRoot?.querySelector('.activator');
      if (initialButton) { bootRequested = true; initialButton.click(); }
    }
    if (!runtimeRoot?.querySelector('.activator')) return false;
    if (!runtimeRoot.querySelector('[data-dudes-chat-style]')) {
      const style = document.createElement('style');
      style.dataset.dudesChatStyle = '';
      style.textContent = nativeStyle;
      runtimeRoot.append(style);
      nativeObserver?.disconnect();
      nativeObserver = new MutationObserver(() => {
        if (!nativeHost.hasAttribute('open') && !overlay.hidden) dismiss(false);
      });
      nativeObserver.observe(nativeHost, { attributes: true, attributeFilter: ['open'] });
    }
    return true;
  }
  function dismiss(closeNative = true) {
    clearTimeout(pendingTimer);
    overlay.hidden = true;
    document.documentElement.classList.remove('dudes-chat-open');
    document.querySelectorAll('[data-dudes-chat-open]').forEach(link => link.setAttribute('aria-expanded', 'false'));
    if (closeNative && nativeHost?.hasAttribute('open')) runtimeRoot?.querySelector('.activator')?.click();
    opener?.focus({ preventScroll: true });
  }
  function launch() {
    if (overlay.hidden) return;
    if (connect()) {
      if (!nativeHost.hasAttribute('open')) runtimeRoot.querySelector('.activator').click();
      document.documentElement.classList.add('dudes-chat-open');
      overlay.querySelector('.dudes-chat-loading').hidden = true;
      closeButton.focus({ preventScroll: true });
      return;
    }
    if (++attempts < 60) pendingTimer = setTimeout(launch, 250);
    else overlay.querySelector('.dudes-chat-loading p').textContent = overlay.dataset.unavailable;
  }
  if (overlay) {
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-dudes-chat-open]');
      if (!link) return;
      event.preventDefault();
      opener = link;
      overlay.hidden = false;
      attempts = 0;
      link.setAttribute('aria-expanded', 'true');
      closeButton.focus({ preventScroll: true });
      launch();
    });
    closeButton.addEventListener('click', () => dismiss());
    overlay.addEventListener('click', event => { if (event.target === overlay) dismiss(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !overlay.hidden) dismiss(); });
    window.addEventListener('pagehide', () => dismiss());
  }
  } catch(e) { console.error(e); }
})();

})();
